module.exports = __webpack_public_path__ + "d9e38bb908bc3c385deceb673e8e7b3d.png";